import { Box, Grid } from "@mui/material";
import { cloudfrontUrl } from "../../../constants/imageUrl";
import useIsMobile from "../../../hooks/useIsMobile";

export default function Header() {
  const isMobile = useIsMobile("md");

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Grid container sx={{ height: "100%" }}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#ff0009",
            }}
          >
            <div className="flex">
              <Box
                component="img"
                src={`${cloudfrontUrl}/about/ksmweb_aboutus_redonwhite_${
                  isMobile ? "mobile" : "desktop"
                }.png`}
                alt="Header KSM"
                sx={{
                  width: "100%",
                  height: "auto",
                }}
              />
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
